export function testUserAgentRegex(userAgentPattern: string) {
  const regex = new RegExp(userAgentPattern);
  return regex.test(navigator.userAgent);
}
